// extracted by mini-css-extract-plugin
export var readonly = "_hz-1";
export var star = "_hz-0";